<template>
  <div class="manuscript">
    <div v-if="$store.state.brandMoudle.activeName === '0'" class="header clearBoth">
      <span class="title">Article</span>
      <span class="amount" @click="toManuscript">View all {{ $parent.$parent.result.article.totalRecords }} search results >></span>
    </div>
    <div v-if="$store.state.brandMoudle.activeName === '2'" class="header clearBoth">
      <span class="describe">The system searches for {{
          $parent.$parent.result.article.totalRecords
        }} results for you</span>
      <div class="sortSelect"/>
    </div>
    <ul class="dataList">
      <div v-loading="$parent.$parent.bool.articleLoading">
        <li v-for="(item, index) in $parent.$parent.result.article.pageData"
            v-if="$store.state.brandMoudle.activeName === '0' && index < 3" @click="toDetail(item)">
          <p class="dataTitle" v-html="item.title"></p>
          <p class="descript">{{ item.articleAbstract }}</p>
          <div class="tag">
            <div class="tagClass">
              <template v-if="item.companyTags && item.companyTags.length>0">
                <el-tag color="#ec808d" style="color: #ffffff">{{ item.companyTags[0] | lengthFormate }}</el-tag>
              </template>

              <template v-if="item.industryTags && item.industryTags.length>0">
                <el-tag color="#81d3f8" style="color: rgb(29 68 122)">{{
                    item.industryTags[0] | lengthFormate
                  }}
                </el-tag>
              </template>

              <template v-if="item.positiveTags && item.positiveTags.length>0">
                <el-tag color="#aff0b5" style="color: rgb(21 184 54)">{{ item.positiveTags[0] | tagFormate }}</el-tag>
              </template>

              <template v-if="item.negativeTags && item.negativeTags.length>0">
                <el-tag color="#ffe4ba" style="color:  rgb(255 142 32)">{{ item.negativeTags[0] | tagFormate }}</el-tag>
              </template>
            </div>

            <div class="source">
              <span>source: {{ item.pubMedia }}</span>
              <span>published: {{ item.pubTime | timeFormate }}</span>
            </div>
          </div>
        </li>
      </div>
      <div v-loading="$parent.$parent.bool.articleLoading">
        <li v-for="(item, index) in $parent.$parent.result.article.pageData" v-if="$store.state.brandMoudle.activeName === '2'"
            @click="toDetail(item)">
          <p class="dataTitle" v-html="item.title"></p>
          <p class="descript">{{ item.articleAbstract }}</p>
          <div class="tag">
            <div class="tagClass">
              <template v-if="item.companyTags && item.companyTags.length>0">
                <el-tag color="#ec808d" style="color: #ffffff">{{ item.companyTags[0] | lengthFormate }}</el-tag>
              </template>

              <template v-if="item.industryTags && item.industryTags.length>0">
                <el-tag color="#81d3f8" style="color: rgb(29 68 122)">{{ item.industryTags[0] | lengthFormate }}
                </el-tag>
              </template>

              <template v-if="item.positiveTags && item.positiveTags.length>0">
                <el-tag color="#aff0b5" style="color: rgb(21 184 54)">{{ item.positiveTags[0] | tagFormate }}</el-tag>
              </template>

              <template v-if="item.negativeTags && item.negativeTags.length>0">
                <el-tag color="#ffe4ba" style="color: rgb(255 142 32)">{{ item.negativeTags[0] | tagFormate }}</el-tag>
              </template>
            </div>

            <div class="source">
              <span>source: {{ item.pubMedia }}</span>
              <span>published: {{ item.pubTime | timeFormate}}</span>
            </div>
          </div>
        </li>
      </div>
    </ul>
    <el-pagination v-if="$store.state.brandMoudle.activeName === '2'" :current-page.sync="$parent.$parent.page.article.page"
                   :page-size.sync="$parent.$parent.page.article.size"
                   :total="$parent.$parent.result.article.totalRecords" background
                   layout="total, prev, pager, next, jumper" @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"/>
  </div>
</template>

<script>
import request from '@/views/brand/utils/request'

export default {
  name: 'manuscript',
  watch: {
    '$parent.$parent.activeName' () {
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    }
  },
  filters: {
    lengthFormate (value) {
      if (value && value !== '' && value.length > 20) {
        return value.substring(0, 20) + '...'
      }
      return value
    },
    tagFormate (value) {
      let result = value
      if (value && value !== '') {
        const tagArray = value.split('\\')
        result = tagArray[tagArray.length - 1]
        if (result.length > 20) {
          return result.substring(0, 20) + '...'
        }
      }
      return result
    },
    timeFormate(value){
      if(value && value !== null && value !== ''){
        return value.substring(3)
      }
      return value
    }
  },
  methods: {
    getArticleList () {
      const data = { keywords: this.$parent.$parent.keywords }
      this.dataList = []
      this.count = 0
      request({ data, params: { ...this.page }, method: 'post', url: '/api/client/search/article' }).then(result => {
        this.dataList = result.data.pageData
        this.count = result.data.totalRecords
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      })
    },
    isFocus (index) {
      this.dataList[index].focusBtn = !this.dataList[index].focusBtn
    },
    toManuscript () {
      this.$store.commit('setActiveName', '2')
    },
    toDetail (item) {
      this.$router.push({ path: '/articleDetail', query: { uid: item.uid, pubTime: item.pubTime, source: 'search' } })
    },
    handleSizeChange () {
      this.$parent.$parent.page.article.page = 1
      this.$parent.$parent.getArticleList()
    },
    handleCurrentChange () {
      this.$parent.$parent.getArticleList()
    }
  }
}
</script>

<style scoped>
.header {
  border-bottom: 2px solid #ededed;
  padding-bottom: 20px;
  text-align: left;
}

.header .title {
  float: left;
  height: 50px;
  line-height: 50px;
  border-left: 12px solid #2f8eff;
  font-size: 18px;
  font-weight: bold;
  padding-left: 8px;
}

.header .amount {
  float: right;
  line-height: 50px;
  font-size: 14px;
  cursor: pointer;
  color: #AAAAAA;
}

.header .describe {
  font-size: 14px;
  font-weight: 400;
  color: #AAAAAA;
}

.sortSelect {
  float: right;
}

/*enterprise*/
.dataList div li {
  text-align: left;
  padding: 24px 20px 44px 20px;
  border-bottom: 2px solid #e0e0e0;
  cursor: pointer;
}

.dataList div li:hover {
  background: #eeeeee;
}

.dataList div li .dataTitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #3a68b1;
  font-weight: bold;
}

.dataList div li .descript {
  font-size: 12px;
  margin: 12px 0;
  width: 66%;
  color: #333333;
  font-weight: 400;
  font-style: normal;
}

.dataList div li .tagClass {
  width: 65%;
  float: left;
}

.dataList div .tag .source {
  color: #AAAAAA;
  font-size: 12px;
  float: right;
  width: 35%;
  line-height: 24px;
  text-align: right;
}

.dataList div .tag .source span:first-child {
  margin-right: 8px;
}

.manuscript .el-pagination {
  margin-top: 20px;
}

.clearBoth:after {
  content: '';
  display: block;
  clear: both;
}

.manuscript {
  /*padding-top: 10px;*/
}
</style>
